import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { Router } from '@angular/router';
import { GridBasedLayoutComponent } from '../../components/tables/grid-based-layout/grid-based-layout.component';
import { SocialAiListOfPostsTableComponent } from '../../components/tables/social-ai-list-of-posts-table/social-ai-list-of-posts-table.component';

@Component({
  selector: 'app-social-ai-list-of-posts',
  standalone: true,
  imports: [
    CommonModule,
    GridBasedLayoutComponent,
    SocialAiListOfPostsTableComponent,
    MatButtonToggleModule
  ],
  templateUrl: './social-ai-list-of-posts.component.html',
  styleUrls: ['./social-ai-list-of-posts.component.scss']
})
export class SocialAiListOfPostsComponent {

  viewMode: 'grid' | 'list' = 'grid'; // default: grid
  loading = false;
  isMobile = window.innerWidth < 549;


  constructor(private router: Router) {}

  ngOnInit() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1200);
  }

  createNewPost() {
  this.router.navigateByUrl('/create-post');
  }

  createBulkPost() {
    this.router.navigateByUrl('/bulk-upload');
  }

  onViewChange(event: any) {
    this.loading = true;

    setTimeout(() => {
      this.viewMode = event.value;
      this.loading = false;
    }, 1200);
  }
}
